import { HttpClient } from 'api/http-client';
import { ViewType, View, ViewCustomisationPayload } from './types';

const baseUrl = '/view-filters';
const baseUrlProject = '/view-filters/project';

export class ViewClient extends HttpClient {
  public getAllViews = <ViewDefinitionT>(
    viewType: ViewType,
  ): Promise<View<ViewDefinitionT>[]> =>
    this.get<View<ViewDefinitionT>[]>(`${baseUrl}?viewType=${viewType}`);

  public customiseView = (payload: ViewCustomisationPayload): Promise<void> =>
    this.put(`${baseUrl}/customise`, payload);

  public getProjectListViews = <ViewDefinitionT>(): Promise<
    View<ViewDefinitionT>[]
  > =>
    this.get<View<ViewDefinitionT>[]>(
      `${baseUrl}?viewType=${ViewType.ProjectList}`,
    );

  public getSprintListViews = <ViewDefinitionT>(): Promise<
    View<ViewDefinitionT>[]
  > =>
    this.get<View<ViewDefinitionT>[]>(
      `${baseUrl}?viewType=${ViewType.SprintList}`,
    );

  public getAllViewsCustomRpeort = <ViewDefinitionT>(
    viewType: ViewType,
    viewSourceId: number,
  ): Promise<View<ViewDefinitionT>[]> =>
    this.get<View<ViewDefinitionT>[]>(
      `${baseUrl}?viewType=${viewType}&viewSourceId=${viewSourceId}`,
    );

  public saveView = <ViewDefinitionT>(
    view: Omit<View<ViewDefinitionT>, 'viewId' | 'createdBy'>,
  ): Promise<View<ViewDefinitionT>> =>
    this.post<
      View<ViewDefinitionT>,
      Omit<View<ViewDefinitionT>, 'viewId' | 'createdBy'>
    >(baseUrl, view);

  public updateView = <ViewDefinitionT>(
    view: View<ViewDefinitionT>,
  ): Promise<View<ViewDefinitionT>> =>
    this.put<View<ViewDefinitionT>, View<ViewDefinitionT>>(
      `${baseUrl}/${view.viewId}`,
      view,
    );

  public deleteView = <ViewDefinitionT>(
    view: View<ViewDefinitionT>,
  ): Promise<void> =>
    this.delete<View<ViewDefinitionT>, void>(`${baseUrl}/${view.viewId}`);

  public getAllProjectTaskViews = <ViewDefinitionT>(
    projectId: string,
  ): Promise<View<ViewDefinitionT>[]> =>
    this.get<View<ViewDefinitionT>[]>(
      `${baseUrlProject}/${projectId}?viewType=${ViewType.ProjectTaskList}`,
    );
}

export const ViewApI = new ViewClient();
